import { render, staticRenderFns } from "./game-mobile.vue?vue&type=template&id=5264aec1&scoped=true"
import script from "./game-mobile.vue?vue&type=script&lang=js"
export * from "./game-mobile.vue?vue&type=script&lang=js"
import style0 from "./game-mobile.vue?vue&type=style&index=0&id=5264aec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264aec1",
  null
  
)

export default component.exports